import React, { useState } from 'react'
import { IconButton, Dialog, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import DialogView from '../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'
import { connect } from 'react-redux'
import { deleteProyeccionExportador } from '../../actions/listados'

function DeleteProyeccionExportador (props) {
  const { proyeccion, deleteProyeccionExportador } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const onDelete = () => {
    const fecha = proyeccion.fecha
    const cereal = proyeccion.cereal.trim()
    const exportador = proyeccion.cuitExportador
    deleteProyeccionExportador(fecha, cereal, exportador)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={onDelete}
          cancelCallback={handleClose}
          title='Eliminar proyeccion para exportador'
          content={<DialogConfirmacionContent
            message='¿Está seguro que desea eliminar la proyeccion seleccionada?'
          />
          }
        />
      </Dialog>

      <Tooltip title={'Eliminar'}>
        <IconButton onClick={handleOpen}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

const mapActionsToProps = {
  deleteProyeccionExportador
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DeleteProyeccionExportador)
